<!--
  Nuxt 错误页面
  不依赖 default 布局，避免布局加载失败时的递归错误
-->
<template>
  <div style="text-align:center;padding:100px 20px;font-family:Arial,sans-serif;">
    <h1 v-if="error.statusCode === 404" style="font-size:72px;color:#ccc;">404</h1>
    <h1 v-else style="font-size:48px;color:#e4393c;">Error</h1>
    <p style="font-size:18px;color:#666;margin-top:20px;">
      {{ error.statusCode === 404 ? 'Page not found' : 'Something went wrong' }}
    </p>
    <a href="/" style="display:inline-block;margin-top:30px;padding:10px 30px;background:#13AF87;color:#fff;text-decoration:none;border-radius:4px;">
      Back to Home
    </a>
  </div>
</template>

<script>
export default {
  props: ['error']
}
</script>
